import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData, { GameVersions } from '../gameData';
import PatternCardItem from './PatternCardItem';

export default class CardSelectGroup extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene,patternData) {
    super(scene);

    this.allCards = [];

    /** @type {{ id: number,card:PatternCardItem,offsetX: number,offsetY: number }[]} */
    this.pressPts = [];

    if (gameData.gameVersion === GameVersions.Number) {
      for (let i = 0; i < patternData.length; i++) {
        if (patternData[i].filled !== true) {
          const card = new PatternCardItem(this.scene, patternData[i].val);
          this.allCards.push(card);
        }
      }

      while (this.allCards.length < 10) {
        const randomAnswer = patternData[0].val * Phaser.Math.Between(1,10);
        const randomCard = new PatternCardItem(this.scene, randomAnswer);
        this.allCards.push(randomCard);
      }
    }
    else {
      let hasVariety = false;
      let nameCheck = '';
      const shapeNames = [];
      for (let i = 0; i < patternData.length; i++) {
        const pShapeName = patternData[i].val;
        if (patternData[i].filled !== true) {
          const card = new PatternCardItem(this.scene, pShapeName);
          this.allCards.push(card);
          if (nameCheck !== '' && pShapeName !== nameCheck) hasVariety = true;
          nameCheck = pShapeName;
        }

        if (shapeNames.indexOf(pShapeName) === - 1) shapeNames.push(patternData[i].val);
      }

      while (this.allCards.length < 10) {
        let randomAnswer = shapeNames[Phaser.Math.Between(0,shapeNames.length - 1)];
        if (randomAnswer !== nameCheck) hasVariety = true;
        nameCheck = randomAnswer;

        // if every chosen card happens to be the same shape, find at least one different
        if (this.allCards.length === 9 && hasVariety === false) {
          randomAnswer = shapeNames.indexOf(nameCheck) === 0 ? shapeNames[1] : shapeNames[0];
        }
        const randomCard = new PatternCardItem(this.scene, randomAnswer);
        this.allCards.push(randomCard);
      }
    }

    this.allCards = Phaser.Utils.Array.Shuffle(this.allCards);

    this.showGroup();
  }

  showGroup () {
    let xPos = 0;
    let yPos = 0;
    const spacing = this.allCards[0].getBounds().width + 10;
    for (let i = 0; i < this.allCards.length; i++) {
      const card = this.allCards[i];
      card.x = xPos;
      card.y = yPos;
      this.add(card);
      xPos += spacing;
      if (xPos > spacing * 4) {
        xPos = 0;
        yPos += card.getBounds().height + 10;
      }
    }

    ABCyaPhaser.Container.setContainerInteractive(this, false);
    this.scene.input.setDraggable(this, true);

    this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.handlePressDown, this);
    this.on(Phaser.Input.Events.GAMEOBJECT_DRAG, this.handlePressMove, this);
    this.on(Phaser.Input.Events.GAMEOBJECT_DRAG_END, this.handlePressUp,this);
  }

  /**
   * 
   * @param {Phaser.Input.Pointer} pointer 
   */
  handlePressDown (pointer) {
    // need listener on whole group so the pointerIDs match up, check stage position and select card under pointer
    const pointerX = pointer.x - this.x;
    const pointerY = pointer.y - this.y;

    for (let i = 0; i < this.allCards.length; i++) {
      const cs = this.allCards[i];
      if (pointerX > cs.x && pointerX < cs.x + cs.getBounds().width && pointerY > cs.y && pointerY < cs.y + cs.getBounds().height) {

        this.selectCard(cs, pointer.x, pointer.y, pointer.id);
        break;
      }
    }
  }

  selectCard (selectedCard,xPos,yPos,pressId) {
    const card = new PatternCardItem(this.scene, selectedCard.val);
    this.add(card);
    card.x = xPos + this.x - (card.getBounds().width / 2);
    card.y = yPos + this.y - (card.getBounds().height / 2);

    const pressObj = { id: pressId,card,offsetX: selectedCard.x - xPos,offsetY: selectedCard.y - yPos };

    if (pressId === -1) {
      this.pressPts = [pressObj];
    }
    else {
      this.pressPts.push(pressObj);
    }
  }

  /**
   * 
   * @param {Phaser.Input.Pointer} pointer 
   */
  handlePressMove (pointer) {
    if (this.pressPts.length > 0) {
      let p;
      if (pointer.id === -1) {
        p = this.pressPts[0];
      }
      else {
        for (let i = 0; i < this.pressPts.length; i++) {
          if (pointer.id === this.pressPts[i].id) {
            p = this.pressPts[i];
            break;
          }
        }
      }

      p.card.x = pointer.x - this.x - (p.card.getBounds().width / 2);
      p.card.y = pointer.y - this.y - (p.card.getBounds().height / 2);
    }
  }

  /**
   * 
   * @param {Phaser.Input.Pointer} pointer 
   */
  handlePressUp (pointer) {
    if (this.pressPts.length > 0) {
      let droppedItem;
      if (pointer.id === -1) {
        droppedItem = this.pressPts[0].card;
        this.pressPts = [];
      }
      else {
        // find pressPt with id
        const len = this.pressPts.length;
        for (let i = 0; i < len; i++) {
          if (this.pressPts[i].id === pointer.id) {
            droppedItem = this.pressPts[i].card;
            this.pressPts.splice(i,1);
            break;
          }
        }
      }

      // check card position
      this.emit('PLACE_ITEM', { _placedItem: droppedItem });
    }
  }

  cleanUpSelect() {
    this.off(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.handlePressDown, this);
    this.off(Phaser.Input.Events.GAMEOBJECT_DRAG, this.handlePressMove, this);
    this.off(Phaser.Input.Events.GAMEOBJECT_DRAG_END, this.handlePressUp,this);
  }
}